﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadReplaceComponentField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadReplaceComponentField, eOutputFieldType.cadReplaceComponent)
export class CadReplaceComponentField extends OutputField implements ICadReplaceComponentField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public filePath: string;
    public componentToReplace: string;
    public newName: string;
    public partFamilyName: string;
    public interchangeGroupCompID: string;
}
